import { RespiratoryCondition, RespiratorySubCondition } from "./respiratory";
import { HeartCondition, HeartSubCondition } from "./heart";
import { CancerCondition } from "./cancer";
import { StrokeCondition } from "./stroke";
import { DiabetesCondition } from "./diabetes";
import { HypertensionCondition, HypertensionReading } from "./hypertension";
import { CholesterolCondition, CholesterolReading } from "./cholesterol";
import { MultiplesclerosisCondition } from "./multiplesclerosis";
import { NeurologicalCondition, NeurologicalSubCondition } from "./neurological";
import { OtherCondition } from "./other";

export type * from "./cancer";
export type * from "./heart";
export type * from "./respiratory";
export type * from "./stroke";
export type * from "./hypertension";
export type * from "./diabetes";
export type * from "./cholesterol";
export type * from "./multiplesclerosis";
export type * from "./other";
export type * from "./neurological";

export enum PrescribedConditionTypes {
  Heart = "Heart",
  Respiratory = "Respiratory",
  Cancer = "Cancer",
  Stroke = "Stroke",
  Diabetes = "Diabetes",
  Hypertension = "Hypertension",
  Cholesterol = "Cholesterol",
  Multiplesclerosis = "Multiple Sclerosis",
  Neurological = "Neurological",
  Other = "Other"
}

export type Medication = {
  syntheticId: number,
  id: number,
  name: string,
  type: string,
  medicationStartDate: string | null,
  dosage: number | null,
  dosageUnits: string | null,
  frequencyUnits: string | null,
  frequency: number | null,
};

export type SubConditions = RespiratorySubCondition | HeartSubCondition | NeurologicalSubCondition;
export type Readings = HypertensionReading | CholesterolReading;

export type Condition<T> =
{
    id: number,
    name: string,
    code: string | null,
    type: T,
    subConditions?: SubConditions[],
    medications?: Medication[],
    readings?: Readings[],
    [key: string]: unknown
}

export type MedicalCondition =
  | HeartCondition
  | RespiratoryCondition
  | CancerCondition
  | StrokeCondition
  | DiabetesCondition
  | HypertensionCondition
  | CholesterolCondition
  | MultiplesclerosisCondition
  | OtherCondition
  | NeurologicalCondition

export type PersonData = {
    dob: string
}

export type SubCondition = {
  diagnosisdate: string,
  syntheticId: number,
}
